// extracted by mini-css-extract-plugin
module.exports = {"root":"IdealTenant_root__TS7M8","rows":"IdealTenant_rows__UzZJP","row":"IdealTenant_row__U4412"};